<div class="dialog-root">
  <div class="dialog-header">
    <div class="left">
      <mat-icon>edit</mat-icon>
      <div class="title-block">
        <span class="title">Edit question</span>
        <span class="subtitle">Editing a single response — small changes only</span>
      </div>
    </div>
    <button mat-icon-button aria-label="Close" class="close-btn" (click)="closeCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <app-question [question]="data.question" [questionnaireAnswer]="qa$" (changeAnswer)="onChange($event)"></app-question>
  </div>

  <div class="dialog-footer">
    <div class="buttons">
      <button class="def-button alt" (click)="closeCancel()">Cancel</button>
      <button class="def-button primary" (click)="saveAndClose()">Save</button>
    </div>
  </div>
</div>
